<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      errorMessage: errorMessage$ | async,
      repeaterQuestions: repeaterQuestions$ | async,
      helpText: helpText$ | async,
      readOnly: readOnly$ | async,
    };
    as data
  ) {
    <div class="form-group question-container-inner" [formGroup]="questionForm">
      <lib-input-container
        [headLine]="
          question.translations?.list['headLine']
            | translate: data.activeLang : question.structure.headLine
        "
        [description]="
          question.translations?.list['description']
            | translate: data.activeLang : question.structure.description
        "
        [labelPrefix]="questionNumber$ | async"
        [label]="
          question.translations?.list['title']
            | translate: data.activeLang : question.title
        "
        [questionMarkText]="
          question.translations?.list['questionMarkText']
            | translate: data.activeLang : question.structure.questionMarkText
        "
        [for]="question.id"
        [required]="minNumberOfRepeatables && minNumberOfRepeatables > 0"
        [helpText]="data.helpText"
        [errorText]="data.errorMessage"
      >
        <lib-list
          [addMoreVisible]="!data.readOnly && showAddRepeatableButton"
          [addMoreText]="t('repeater_btn_add')"
          (addMore)="addRepeatable()"
          (blurred)="onBlur()"
        >
          @for (
            r of repeatablesControl;
            track trackByFn(i, r);
            let i = $index
          ) {
            <lib-list-item
              [removeVisible]="!data.readOnly"
              (remove)="deleteRepeatable(i)"
            >
              <div view>
                @for (
                  questionRow of questionsOrder;
                  track trackByFn($index, questionRow)
                ) {
                  <div class="row">
                    @for (
                      questionId of questionRow;
                      track trackByFn($index, questionId)
                    ) {
                      <div class="col">
                        <lib-question
                          [questionFormGroup]="
                            data.repeaterQuestions[i][questionId]
                          "
                          [showQuestion]="true"
                          [labelPrefix]="i + '_'"
                          [followUpLevel]="0"
                          [showAllFollowUps]="showAllFollowUps"
                          [questionsInRow]="questionRow.length"
                          [repeaterGroupId]="r.value.id"
                        ></lib-question>
                      </div>
                    }
                  </div>
                }
              </div>
            </lib-list-item>
          }
        </lib-list>
        @if (maxNumberOfRepeatables) {
          <span class="repeatable-count"
            >{{ numberOfRepeatables }}/{{ maxNumberOfRepeatables }}</span
          >
        }
      </lib-input-container>
    </div>
  }
</ng-container>
